<div *ngIf="!dismissed" class="flex p-3 mb-4 rounded border" [ngClass]="alertClass" role="alert">
  <div class="flex items-start">
    <div class="mr-2 flex-shrink-0" *ngIf="showIcon">
      <lucide-icon [name]="icon" class="size-5" [ngClass]="iconClass"></lucide-icon>
    </div>

    <div class="flex-grow">
      <ng-container *ngIf="message; else contentProjection">
        {{ message }}
      </ng-container>

      <ng-template #contentProjection>
        <ng-content></ng-content>
      </ng-template>
    </div>

    <div *ngIf="dismissible" class="ml-2 flex-shrink-0">
      <button type="button" class="text-gray-500 hover:text-gray-700" aria-label="Close" (click)="dismiss()">
        <lucide-icon [name]="XIcon" class="size-4"></lucide-icon>
      </button>
    </div>
  </div>
</div>
